import React, {useContext, useEffect, useState} from "react";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export default function HeadlineCard({id, photo, title, description, clickFunction}){
	
	const [percentage, setPercentage] = useState(0);
	const [imgUrl, setImgUrl] = useState("");
	
	useEffect(() => {
		setPercentage(Math.round(Math.random()*100));
		try{
			if(photo.length > 0){
				let blob = new Blob([new Uint8Array(atob(photo).split("").map(char => char.charCodeAt(0)))], { type: 'image/png' });
	      let url = URL.createObjectURL(blob);
	      setImgUrl(url);
	     }
		}
		catch(e){}
	}, [id]);
	
	const thisContainer = {
			display:'flex',
			backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
			width:"calc(100% - 40px)",
			boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
			borderRadius:"5px",
			margin:"10px",
			flexDirection:"column"
	};
	
	
	const topContainer = {
		display:'flex',
		width:"100%",
		height:"120px"
	};
	
	const photoContainer = {
		display:"flex",
		padding:"10px"
	};
	
	const photoStyle = {
		display:"flex",
		width:"150px",
		height:"100px",
		borderRadius:"10px"
	};
	
	const textContainer = {
		display:'flex',
		flexDirection:"column",
		flexGrow:"1",
		margin:"20px"
	};
	
	const titleContainer = {
		display:'flex',
		fontSize:"14px",
		color:"white",
		fontWeight:"bold"
	};
	
	const descriptionContainer = {
		display:'flex',
		fontSize:"12px",
		color:"white",
		marginTop:"10px"
	}; 
	
	const bottomContainer = {
		display:'flex',
		width:"100%",
		flexDirection:"column",
		marginTop:"-30px"
	};
	
	const percentageNumber = {
		display:'flex',
		width:"100px",
		height:"20px",
		paddingTop:"10px",
		borderTopLeftRadius:"5px",
		borderTopRightRadius:"5px",
		marginRight:"10px",
		//backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		backgroundColor:"#000",
		alignItems:"center",
		justifyContent:"space-around",
		marginLeft:"calc(100% - 110px)",
		fontSize:"14px",
		color:"white",
		fontWeight:"bold"
	};
	
	const percentageHolder = {
		display:"flex",
		width:"calc(100% - 20px)",
		marginBottom:"10px",
		marginLeft:"10px",
		//backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		backgroundColor:"#000",
		alignItems:"center",
		borderTopLeftRadius:"5px",
		borderBottomLeftRadius:"5px",
		height:"10px",
		borderBottomRightRadius:"5px"
	};
	
	const percentageIndicatorHolder = {
		display:"flex",
		width:"calc(100% - 100px)"
	}
	
	const percentageIndicator = {
		display:"flex",
		width:percentage +"%",
		backgroundColor:"#1DDBD5",
		height:"10px",
		borderRadius:"5px",
		opacity:"0.9"
	}
	
	return (
		<div style={thisContainer} onClick={clickFunction}>
			<div style={topContainer}>
				<div style={photoContainer}>
					<img src={imgUrl} style={photoStyle}/>
				</div>
				<div style={textContainer}>
					<div style={titleContainer}>
						{title}
					</div>
					<div style={descriptionContainer}>
						{description}
					</div>
				</div>
			</div>
			
		</div>
	);
}